import { EqualityFn, useSelector as useReduxSelector } from 'react-redux';
import { ContentPlanRootState } from '../elements/contentPlan/store';

type Fn<T> = (s: ContentPlanRootState) => T;

export const useSelector = <T>(fn: Fn<T>, equalityFn?: EqualityFn<T>): T =>
  useReduxSelector(fn, equalityFn);
